var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3438 30L38.0312 25.3125C38.6406 24.75 38.6406 23.8125 38.0312 23.25L37 22.2188C36.4375 21.6094 35.5 21.6094 34.9375 22.2188L30.25 26.9062L25.5156 22.2188C24.9531 21.6094 24.0156 21.6094 23.4531 22.2188L22.4219 23.25C21.8125 23.8125 21.8125 24.75 22.4219 25.3125L27.1094 30L22.4219 34.7344C21.8125 35.2969 21.8125 36.2344 22.4219 36.7969L23.4531 37.8281C24.0156 38.4375 24.9531 38.4375 25.5156 37.8281L30.25 33.1406L34.9375 37.8281C35.5 38.4375 36.4375 38.4375 37 37.8281L38.0312 36.7969C38.6406 36.2344 38.6406 35.2969 38.0312 34.7344L33.3438 30Z",
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.519fbe5c60faa5aa2069857257465701.svg";
export { ForwardRef as ReactComponent };